import { effect, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RouteNames } from '../enums/routes.enum';
import { ConfigService } from './config.service';
import { SidePanelService } from './side-panel.service';

@Injectable({
	providedIn: 'root'
})
export class PanelRoutingService {
	private isMobile = false;
	noPanels: string[] = [
		RouteNames.Root,
		RouteNames.StyleGuide,
		RouteNames.Login,
		RouteNames.SignUp,
		RouteNames.SignUpEmail,
		RouteNames.SignUpPassword,
		RouteNames.PasswordReset,
		RouteNames.ForgotPassword,
		RouteNames.Onboard
	];
	lastPath: string;

	constructor(
		private router: Router,
		private configService: ConfigService,
		private sidePanelService: SidePanelService
	) {
		effect(() => {
			this.isMobile = this.configService.isMobileSignal();
		});
	}

	navigate(
		routeSegments: string[],
		params?: Record<string, any>,
		options?: {
			reloadOnSameUrl?: boolean;
		}
	): void {
		const navigationExtras: Record<string, any> = {
			queryParams: params
		};
		if (options?.reloadOnSameUrl) {
			navigationExtras['onSameUrlNavigation'] = 'reload';
		}

		if (this.isMobile || this.noPanels.includes(routeSegments[0])) {
			this.router.navigate(['/', ...routeSegments], navigationExtras);
		} else if (options?.reloadOnSameUrl) {
			void this.reloadDesktopPanelRoute(routeSegments, navigationExtras);
		} else {
			this.router.navigate([{ outlets: { panel: routeSegments } }], navigationExtras);
		}
	}

	private async reloadDesktopPanelRoute(routeSegments: string[], navigationExtras: Record<string, any>): Promise<void> {
		await this.router.navigate([{ outlets: { panel: null } }], { skipLocationChange: true });
		this.sidePanelService.openPanel();
		await this.router.navigate([{ outlets: { panel: routeSegments } }], navigationExtras);
	}

	navigateWithCommands(commands: any[], params?: Record<string, any>): void {
		if (this.isMobile) {
			this.router.navigate(commands, { queryParams: params });
		} else {
			this.router.navigate([{ outlets: { panel: commands } }], { queryParams: params });
		}
	}

	getRouteLink(route: string): any[] {
		return this.isMobile ? ['/', route] : [{ outlets: { panel: [route] } }];
	}

	getRouteLinkWithCommands(commands: any[]): any[] {
		const [route, ...rest] = commands;
		return this.isMobile ? commands : [{ outlets: { panel: [route, ...rest] } }];
	}

	panelRoutingControl(path: string) {
		const noSlashPath = path.replace(/^\/+/, '');

		if (this.noPanels.includes(path)) {
			this.sidePanelService.closePanel();
			if (this.noPanels.includes(this.lastPath)) {
				this.navigate([path]);
			} else {
				this.navigate([this.lastPath]);
				setTimeout(() => {
					this.router.navigate([{ outlets: { panel: null } }]);
					this.navigate([path]);
				}, 500);
			}
		} else {
			const noSlashPath = path.replace(/^\/+/, '');
			this.navigate([noSlashPath]);
			this.sidePanelService.openPanel();
		}
		this.lastPath = noSlashPath;
	}
}
